import React from 'react';
import './AboutPage.css'; // Import the CSS file for styling
import TopMenuBar from '../components/TopMenuBar';

export const AboutPage = () => {
  return (
    <>
      <TopMenuBar />
      <div className="about-page">
        <h1>About Us</h1>
        <div className="vision-section">
          <h2>Our Vision</h2>
          <p>
            Our vision is to empower individuals and families to make informed food choices, 
            reduce waste, and enhance their culinary experiences through innovative technology.
          </p>
        </div>
        <div className="mission-section">
          <h2>Our Mission</h2>
          <p>
            Our mission is to provide a user-friendly platform that connects people with 
            personalized recipes, nutritional information, and tools to manage their pantry 
            effectively, fostering a healthier lifestyle.
          </p>
        </div>
      </div>
    </>
  );
};